import { render, staticRenderFns } from "./select-multiple.vue?vue&type=template&id=1bd5ffda"
import script from "./select-multiple.vue?vue&type=script&lang=js"
export * from "./select-multiple.vue?vue&type=script&lang=js"
import style0 from "./select-multiple.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports